module.exports = {
      id: "icon-audio-play-store-usage",
      viewBox: "0 0 122 41",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#icon-audio-play-store",
      toString: function () {
        return this.url;
      }
    }